
import vue from 'vue';
import Exposure from './exposure';
const exp = new Exposure()

vue.directive('track',{
  bind:function(el, binding){
    const { arg } = binding;
    arg.split('|').forEach(item=>{
      if(item =='exposure'){
        exp.add({el})
      }
    })
  }
})